export default [
  {
    path: '/suppliers',
    name: 'supplier-list',
    props: true,
    component: () => import('@/views/users/suppliers/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des Expéditeurs',
      pageDesc: 'Consultez, filtrez et gérez les expéditeurs logistiques. Utilisez les filtres pour affiner la liste et accédez aux détails de chaque expéditeur.',
      ariaLabel: 'Tableau des expéditeurs logistiques',
      breadcrumb: [
        {
          text: 'Expéditeur',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des expéditeurs',
        },
        {
          text: 'Liste des Expéditeurs',
          active: true,
          ariaLabel: 'Page active : liste des expéditeurs',
        },
      ],
      breadcrumbLabel: 'Liste des Expéditeurs',
      // Allow superadmin to view suppliers list (read-only on UI)
      roles: ['admin', 'manager', 'sales', 'superadmin'],
    },
  },
  {
    path: '/suppliers/create',
    name: 'supplier-add',
    props: true,
    component: () => import('@/views/users/suppliers/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter un Expéditeur',
      pageDesc: 'Ajoutez un nouveau fournisseur logistique en renseignant les informations professionnelles, coordonnées et tarification.',
      ariaLabel: 'Formulaire d’ajout de fournisseur',
      breadcrumb: [
        {
          text: 'Expéditeur',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des expéditeurs',
        },
        {
          text: 'Ajouter Expéditeur',
          active: true,
          ariaLabel: 'Page active : ajout fournisseur',
        },
      ],
      breadcrumbLabel: 'Ajouter Expéditeur',
      roles: ['admin', 'sales'],
    },
  },
  {
    path: '/suppliers/edit/:id',
    name: 'supplier-edit',
    props: true,
    component: () => import('@/views/users/suppliers/Edit.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Modifier un Fournisseur',
      pageDesc: 'Modifiez les informations professionnelles, coordonnées et tarification du fournisseur sélectionné.',
      ariaLabel: 'Formulaire de modification de fournisseur',
      breadcrumb: [
        {
          text: 'Expéditeur',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des expéditeurs',
        },
        {
          text: 'Modifier expéditeur',
          active: true,
          ariaLabel: 'Page active : modification expéditeur',
        },
      ],
      breadcrumbLabel: 'Modifier expéditeur',
      roles: ['admin', 'sales'],
    },
  },
  {
    path: '/suppliers/show/:id',
    name: 'supplier-show',
    props: true,
    component: () => import('@/views/users/suppliers/Show.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Détails du Fournisseur',
      pageDesc: 'Consultez les informations détaillées, statistiques et commandes du fournisseur sélectionné.',
      ariaLabel: 'Détails du fournisseur logistique',
      breadcrumb: [
        {
          text: 'Expéditeur',
          to: { name: 'supplier-list' },
          ariaLabel: 'Retour à la liste des expéditeurs',
        },
        {
          text: 'Détails expéditeur',
          active: true,
          ariaLabel: 'Page active : détails expéditeur',
        },
      ],
      breadcrumbLabel: 'Détails expéditeur',
      // Allow superadmin to open supplier details (read-only)
      roles: ['admin', 'manager', 'sales', 'superadmin'],
    },
  },
  {
    path: '/support-center',
    name: 'supplier-support-center',
    component: () => import('@/views/SupplierSupportCenter.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Centre de Support',
      pageDesc: 'Signalez des bugs, demandez des fonctionnalités ou obtenez une assistance technique',
      ariaLabel: 'Centre de support fournisseur',
      breadcrumb: [
        {
          text: 'Centre de Support',
          active: true,
          ariaLabel: 'Page active : centre de support',
        },
      ],
      breadcrumbLabel: 'Centre de Support',
      roles: ['supplier'],
    },
  },
]
